/**
 * Generates a URL-friendly slug from a given string
 *
 * @param {string} text - The text to convert to a slug
 * @returns {string} A URL-safe slug (lowercase, hyphens, no special chars)
 *
 * @example
 * generateSlug('My Baseball Academy') // => 'my-baseball-academy'
 * generateSlug('Elite Sports Club!') // => 'elite-sports-club'
 * generateSlug('  Multiple   Spaces  ') // => 'multiple-spaces'
 */
export const generateSlug = (text) => {
  if (!text) return '';

  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-') // Replace multiple hyphens with single hyphen
    .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
};
